export default {
  affiliate: {
    redirect: {
      showCheckbox: false,
    }
  }
};
